import clsx from 'clsx';
import * as React from 'react';

import { diffStrings } from '@gitbook/util-tree-merge';

import { DIFF_BACKGROUND_COLORS, DIFF_TEXT_COLORS } from './constants';

/**
 * Render an highlighting of the difference between two strings.
 */
export function TextDiff(props: { before: string; after: string }) {
    const { before, after } = props;

    const diffs = React.useMemo(() => diffStrings(before, after), [before, after]);

    return (
        <>
            {diffs.map((diff) => {
                switch (diff.op) {
                    case '=':
                        return <span key={diff.value}>{diff.value}</span>;
                    case '+':
                        return (
                            <span
                                key={diff.value}
                                className={clsx(
                                    DIFF_TEXT_COLORS.added,
                                    DIFF_BACKGROUND_COLORS.added
                                )}
                            >
                                {diff.value}
                            </span>
                        );
                    case '-':
                        return (
                            <span
                                key={diff.value}
                                className={clsx(
                                    DIFF_TEXT_COLORS.deleted,
                                    DIFF_BACKGROUND_COLORS.deleted
                                )}
                            >
                                {diff.value}
                            </span>
                        );
                }
            })}
        </>
    );
}
